import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  private subject1 = new Subject<any>();
  private subject = new Subject<any>();
  private SaveUserForCore = new Subject<any>();
  private SaveUserForContact = new Subject<any>();
  private HideTaskListCore = new Subject<any>();  
  private SaveUserForCompany = new Subject<any>();
  private searchValue = new Subject<any>();
  private searchValueForModule = new Subject<any>();
  private searchValueForRole = new Subject<any>();
  private sendUserDataModule = new Subject<any>();
  private sendUserCoreDataModule = new Subject<any>();
  private sendUserContactDataModule = new Subject<any>();
  private sendUserCompanyDataModule = new Subject<any>();
  private searchValueForOrganization = new Subject<any>();
  private sendSelectedFolderInSetting = new Subject<any>();  
  private searchValueForPermission = new Subject<any>();
  private sendUserdetails = new Subject<any>();  
  private filteredsearchValueForCore = new BehaviorSubject<any>('');  
  private sendshowRightListing = new Subject<any>();
  private getContactAddFiltersubject = new Subject<any>();
  private getCloseContactFiltersubject = new Subject<any>();
  private getContactClicksubject = new Subject<any>();
  private closeFilterContactEventsubject = new Subject<any>();  
  private sendContactAddFiltersubject = new Subject<any>();
  private sendFilteredValueContactsearchValue = new BehaviorSubject<any>('');
  private sendContactAddListsubject = new Subject<any>();
  private selectedRecordForDeleteCore = new BehaviorSubject<any>('');
  private selectedRecordForDeleteContact = new BehaviorSubject<any>('');
  private selectedRecordForFavoriteCore = new BehaviorSubject<any>('');
  private selectedRecordForFavoriteContact = new BehaviorSubject<any>('');  
  private selectedRecordForDeleteFavoriteCore = new BehaviorSubject<any>('');
  private selectedRecordForDeleteFavoriteContact = new BehaviorSubject<any>(''); 
  public  searchValueForCoreModule = new BehaviorSubject<string>('');
  private searchValueForContactModule = new BehaviorSubject<any>('');  
  private AddListEventForCore = new Subject<any>();
  private AddListEventForContact = new Subject<any>();
  private AddFilterEventForCore = new Subject<any>();
  private AddFilterEventForContact = new Subject<any>();
  private selectedColumnForCore = new BehaviorSubject<any>('');
  private selectedColumnForContact = new BehaviorSubject<any>('');  
  private selectedCFilterNameForCore = new BehaviorSubject<any>('');
  private selectedCFilterNameForContact = new BehaviorSubject<any>('');  
  private selectedDocumentForCore = new BehaviorSubject<any>('');
  private selectedDocumentForFileManager = new BehaviorSubject<any>('');
  private selectedDocumentForChat = new BehaviorSubject<any>('');  
  private selectedDocumentForCoreDetails = new BehaviorSubject<any>('');
  private selectedDocumentForContactDetails = new BehaviorSubject<any>('');
  private selectedDocumentForCompanyDetails = new BehaviorSubject<any>('');
  private selectedDocumentForContact= new BehaviorSubject<any>('');
  private selectedDocumentForCompany = new BehaviorSubject<any>('');
  private sendSelectedFolderFileFormModule = new BehaviorSubject<any>(''); 
  private sendRefreshListForFormModule = new BehaviorSubject<any>('');
  private sendRefreshListForFileManagerModule = new BehaviorSubject<any>('');  
  private sendRefreshDetailsSharedRoleForFormModule = new BehaviorSubject<any>('');  
  private sendRefreshDetailsSharedRoleForFileManagerModule = new BehaviorSubject<any>('');  
  private childFolderListContent = new BehaviorSubject<any>('');
  private loadSharedWithMe = new BehaviorSubject<any>('');
  private childFolderListContentFileManager = new Subject<any>();   
  private getCurrentFormContactName = new BehaviorSubject<any>('');  
  private getCurrentFormFormName = new BehaviorSubject<any>('');  
  private getSendCurrentMenu = new BehaviorSubject<any>('');  
  private getCurrentFormContactNameFileManager = new BehaviorSubject<any>('');  
  private getCurrentFormContactNamedashBoard = new BehaviorSubject<any>('');  
  public  selectedModuleName = new BehaviorSubject<string>('');
  public  FetchDashboardfavourite = new BehaviorSubject<boolean>(false);
  public  Fetchleftmenufielmanager = new BehaviorSubject<boolean>(false);
  public  UpdateUserProfile =new BehaviorSubject<any>(''); 
  public  currentProjectName = new BehaviorSubject<string>('');
  private closePanelFromDocDetailsCore = new BehaviorSubject<any>('');  
  private closePanelFromDocDetailsContact = new BehaviorSubject<any>('');
  private closePanelFromDocDetailsCompany = new BehaviorSubject<any>('');  
  private closePanelFaxForFileManager = new BehaviorSubject<any>('');  
  private sendSelectedFolderIDFromLeftMenu = new BehaviorSubject<any>(''); 
  private sendSelectedFolderIDFromLeftMenuFileManager = new BehaviorSubject<any>('');
  private sendSelectedFolderIDForAddFolderFileManager = new BehaviorSubject<any>(''); 
  private sendProjectNameAlreadyExists = new BehaviorSubject<any>(''); 
  private sendRefreshListForFileManagerAdd = new Subject<any>();   
  private saveMedicationToEntity = new Subject<any>();  
  private SelectedFolderDetailsFromLeftMenuFileManager = new BehaviorSubject<any>(''); 
  private ContactCreateNewParticipantStep2 = new BehaviorSubject<any>('');  
  private totalInbox = new BehaviorSubject<any>(''); 
  private sendSelectedParentFolderIDForMoveFileMangerItem = new BehaviorSubject<any>('');
  private sendSelectedParentFormIDForMoveForm = new BehaviorSubject<any>(''); 
  private RenamedFileManagerItem = new BehaviorSubject<any>('');
  private SetFolderEdtailEmpty = new BehaviorSubject<any>('');
  private SelectedRequestDocumentForCore = new BehaviorSubject<any>('');
  private RemoveRequestDocumentForCore = new BehaviorSubject<any>('');
  private RemoveFaxDocumentForCore = new BehaviorSubject<any>('');
  private FillPlaceholderDocumentForCore = new BehaviorSubject<any>('');  
  private SelectedRequestDocumentForContact = new BehaviorSubject<any>('');
  private RemoveRequestDocumentForContact = new BehaviorSubject<any>('');
  private FillPlaceholderDocumentForContact = new BehaviorSubject<any>('');
  private SelectedRequestDocumentForCompany = new BehaviorSubject<any>('');
  private SelectedFaxDocumentForFileManager = new BehaviorSubject<any>('');  
  private RemoveRequestDocumentForCompany = new BehaviorSubject<any>('');
  private RemoveFaxDocumentForFileManager = new BehaviorSubject<any>('');  
  private FillPlaceholderDocumentForCompany = new BehaviorSubject<any>('');
  private NotificationRead = new BehaviorSubject<any>('');
  private SelectedChatParticipant = new BehaviorSubject<any>('');
  private DeleteChatGroup = new BehaviorSubject<any>('');
  private NewChatMessage = new BehaviorSubject<any>('');
  private AddAttachmentFile = new BehaviorSubject<any>('');
  private MessageUserOrGroup = new BehaviorSubject<any>('');
  private ShowFormsSiderbar = new BehaviorSubject<any>('');
  private SentSelectedDetail = new BehaviorSubject<any>('');
  private OrganizationSelectedDetail = new BehaviorSubject<any>('');
  private NextPreviousDocumentFromCore = new BehaviorSubject<any>('');
  private NextPreviousForRightPanelFromCore = new BehaviorSubject<any>('');
  private NextPreviousDocumentFromContact = new BehaviorSubject<any>('');
  private NextPreviousForRightPanelFromContact  = new BehaviorSubject<any>('');
  private NextPreviousDocumentFromCompany = new BehaviorSubject<any>('');
  private NextPreviousForRightPanelFromCompany  = new BehaviorSubject<any>('');
  private NextPreviousForTouchesFromCore  = new BehaviorSubject<any>('');
  private NextPreviousForTaskFromCore  = new BehaviorSubject<any>('');  
  private NextPreviousForTouchesFromContact  = new BehaviorSubject<any>('');
  private NextPreviousForTouchesFromCompany  = new BehaviorSubject<any>('');
  private getEmptyCurrentFormFormName= new BehaviorSubject<any>('');
  private selectedHTMLDataForCore= new BehaviorSubject<any>('');
  private selectedHTMLDataForContact= new BehaviorSubject<any>('');
  private selectedHTMLDataForCompany= new BehaviorSubject<any>('');
  private selectedHTMLDataForForm= new BehaviorSubject<any>('');
  private selectedPdfFormDataForForm= new BehaviorSubject<any>('');
  private sendSelectedDocForBindAIs = new BehaviorSubject<any>('');
  private openAIBindingPopup = new BehaviorSubject<any>('');
  private UpdateDataUsingAIForCore  = new BehaviorSubject<any>(''); 
  private sendSelectedDocForBindAIsForms = new BehaviorSubject<any>('');
  
  private sendRefreshListForCore = new BehaviorSubject<any>('');
  
  private senndGroupingList3C = new Subject<any>();
  private sendSelectedDocForBindAIToolss = new BehaviorSubject<any>('');
  
  private sendDataGoogleDrive = new BehaviorSubject<any>('');
  private sendRefreshListAfterAddingParticipants = new BehaviorSubject<any>('');

  sendSaveUserForCore(): void {
    this.SaveUserForCore.next();
  }

  getSaveUserForCore(): Observable<any> {
    return this.SaveUserForCore.asObservable();
  }

  sendSaveUserForContact(): void {
    this.SaveUserForContact.next();
  }

  getSaveUserForContact(): Observable<any> {
    return this.SaveUserForContact.asObservable();
  }

  sendSaveUserForCompany(): void {
    this.SaveUserForCompany.next();
  }
  getSaveUserForCompany(): Observable<any> {
    return this.SaveUserForCompany.asObservable();
  }

  sendSelectedCoreUser(any): void {
    this.sendUserCoreDataModule.next(any);
  }
  getSelectedCoreUser(): Observable<any> {
    return this.sendUserCoreDataModule.asObservable();
  }

  sendSelectedContactUser(any): void {
    this.sendUserContactDataModule.next(any);
  }
  getSelectedContactUser(): Observable<any> {
    return this.sendUserContactDataModule.asObservable();
  }
  sendSelectedCompanyUser(any): void {
    this.sendUserCompanyDataModule.next(any);
  }
  getSelectedCompanyUser(): Observable<any> {
    return this.sendUserCompanyDataModule.asObservable();
  }

  sendSelectedFolderIdInSetting(any): void {
    this.sendSelectedFolderInSetting.next(any);
  }
  getSelectedFolderIdInSetting(): Observable<any> {
    return this.sendSelectedFolderInSetting.asObservable();
  }

  sendUserDetails(any): void {
    this.sendUserdetails.next(any);
  }
  getUserDetails(): Observable<any> {
    return this.sendUserdetails.asObservable();
  }


  sendSelectedModuleName(filterValue): void {
    this.selectedModuleName.next(filterValue);
  }
  getSelectedModuleName(): Observable<string> {
    return this.selectedModuleName.asObservable();
  }

  //
  sendFetchDashboardfavourite(filterValue): void {
    this.FetchDashboardfavourite.next(filterValue);
  }
  getFetchDashboardfavourite(): Observable<boolean> {
    return this.FetchDashboardfavourite.asObservable();
  }
  //
   //
 sendFetchleftmenufielmanager(filterValue): void {
  this.Fetchleftmenufielmanager.next(filterValue);
}
getFetchleftmenufielmanager(): Observable<boolean> {
  return this.Fetchleftmenufielmanager.asObservable();
}
//
  sendSelectedProjectName(filterValue): void {
    this.currentProjectName.next(filterValue);
  }
  getSelectedProjectName(): Observable<string> {
    return this.currentProjectName.asObservable();
  }

  sendsaveMedicationToEntity(filterValue=""): void {
    this.saveMedicationToEntity.next(filterValue);
  }
  getsaveMedicationToEntity(): Observable<string> {
    return this.saveMedicationToEntity.asObservable();
  }

  sendClosePanelFromDocDetailsCore(filterValue): void {
    this.closePanelFromDocDetailsCore.next(filterValue);
  }
  getClosePanelFromDocDetailsCore(): Observable<string> {
    return this.closePanelFromDocDetailsCore.asObservable();
  }

  sendClosePanelFromDocDetailsContact(filterValue): void {
    this.closePanelFromDocDetailsContact.next(filterValue);
  }
  getClosePanelFromDocDetailsContact(): Observable<string> {
    return this.closePanelFromDocDetailsContact.asObservable();
  }

  sendClosePanelFromDocDetailsCompany(filterValue): void {
    this.closePanelFromDocDetailsCompany.next(filterValue);
  }
  getClosePanelFromDocDetailsCompany(): Observable<string> {
    return this.closePanelFromDocDetailsCompany.asObservable();
  }

  sendClosePanelFaxForFileManager(filterValue): void {
    this.closePanelFaxForFileManager.next(filterValue);
  }
  getClosePanelFaxForFileManager(): Observable<string> {
    return this.closePanelFaxForFileManager.asObservable();
  }

  sendContactUser(id): void {
    this.searchValue.next(id);
  }
  getContactUser(): Observable<any> {
    return this.searchValue.asObservable();
  }

  sendCore1User(id): void {
    this.searchValue.next(id);
  }  
  getCore1User(): Observable<any> {
    return this.searchValue.asObservable();
  }

  sendClickEvent(): void {
    this.subject.next();
  }
  
  sendAddListEvent(): void {
    this.subject.next();
  }


  sendContactAddListEvent(): void {
    this.sendContactAddListsubject.next();
  }
  getsendContactAddListEvent(): Observable<any> {
    return this.sendContactAddListsubject.asObservable();
  }

  sendClearFilterEvent(): void {
    this.subject1.next();
  }
  getClearFilterEvent(): Observable<any> {
    return this.subject1.asObservable();
  }


  sendContactClearFilterEvent(): void {
    this.getCloseContactFiltersubject.next();
  }
  getContactClearFilterEvent(): Observable<any> {
    return this.getCloseContactFiltersubject.asObservable();
  }

  
  sendCloseCoreFilterEvent(): void {
    this.subject.next();
  }
  sendAddFilterEvent(): void {
    this.subject.next();
  }
  
  sendContactAddFilterEvent(): void {
    this.sendContactAddFiltersubject.next();
  }
  getContactAddFilterEvent(): Observable<any> {
    return this.sendContactAddFiltersubject.asObservable();
  }

  sendshowRightListingEvent(): void {
    this.sendshowRightListing.next();
  }
  getshowRightListingEvent(): Observable<any> {
    return this.sendshowRightListing.asObservable();
  }

  getAddFilterEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  

  getCloseCoreFilterEvent(): Observable<any> {
    return this.subject1.asObservable();
  }

  getCloseContactFilterEvent(): Observable<any> {
    return this.getCloseContactFiltersubject.asObservable();
  }
  
  getClearCoreFilterEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  sendAddUserEvent(): void {
    this.subject.next();
  }
  sendClickEventforfields(): void {
    this.subject.next();
  }

  sendClickEventforfieldsForms(): void {
    this.subject.next();
  }

  sendClickEventforCustomFields(): void {
    this.subject.next();
  }
  getClickEventforCustomFields(): Observable<any> {
    return this.subject.asObservable();
  }
  getClickEventforfields(): Observable<any> {
    return this.subject.asObservable();
  }
  getClickEventforfieldsForms(): Observable<any> {
    return this.subject.asObservable();
  }
  
  

  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  sendAddFilterContactEvent(): void {
    this.getContactClicksubject.next();
  }
  getContactClickEvent(): Observable<any> {
    return this.getContactClicksubject.asObservable();
  }


  sendCloseFilterContactEvent(): void {
    this.closeFilterContactEventsubject.next();
  }

  getCloseFilterContactEvent(): Observable<any> {
    return this.closeFilterContactEventsubject.asObservable();
  }


  getAddListEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  
  

  getAddUserEvent(): Observable<any> {
    return this.subject.asObservable();
  }
  
  sendFilterValue(filterValue): void {
    this.searchValue.next(filterValue);
  }

  getSearchValue(): Observable<any> {
    return this.searchValue.asObservable();
  }

  sendSearchValueForModule(filterValue): void {
    this.searchValueForModule.next(filterValue);
  }
  getSearchValueForModule(): Observable<any> {
    return this.searchValueForModule.asObservable();
  }

  sendSearchValueForRole(filterValue): void {
    this.searchValueForRole.next(filterValue);
  }
  getSearchValueForRole(): Observable<any> {
    return this.searchValueForRole.asObservable();
  }

  sendSearchValueForOrganization(filterValue): void {
    this.searchValueForOrganization.next(filterValue);
  }

  getSearchValueForOrganization(): Observable<any> {
    return this.searchValueForOrganization.asObservable();
  }

  sendSearchValueForPermission(filterValue): void {
    this.searchValueForPermission.next(filterValue);
  }

  getSearchValueForPermission(): Observable<any> {
    return this.searchValueForPermission.asObservable();
  }
  

  sendFilteredValueCore(any): void {
    this.filteredsearchValueForCore.next(any);
  }
  getFilteredValueCore(): Observable<any> {
    return this.filteredsearchValueForCore.asObservable();
  }

   sendFilteredValueContact(any): void {
    this.sendFilteredValueContactsearchValue.next(any);
  }
  getFilteredValueContact(): Observable<any> {
    return this.sendFilteredValueContactsearchValue.asObservable();
  }

  

  sendSelectedFilteredNameCore(any): void {
    this.searchValue.next(any);
  }
  getSelectedFilteredNameCore(): Observable<any> {
    return this.searchValue.asObservable();
  }

  sendCloseFilteredValueCore(): void {
    this.subject.next();
  }
  
  getCloseFilteredValueCore(): Observable<any> {
    return this.searchValue.asObservable();
  }
  
  sendClearFilteredValueCore(any): void {
    this.searchValue.next(any);
  }
  getClearFilteredValueCore(): Observable<any> {
    return this.searchValue.asObservable();
  }

  

  
  getSearchValueForUser(): Observable<any> {
    return this.searchValue.asObservable();
  }
  sendSearchValueForUser(filterValue): void {
    this.searchValue.next(filterValue);
  }

  sendSelectedRecordForDeleteCore(any): void {
    this.selectedRecordForDeleteCore.next(any);
  }
  getSelectedRecordForDeleteCore(): Observable<any> {
    return this.selectedRecordForDeleteCore.asObservable();
  }

  sendSelectedRecordForDeleteContact(any): void {
    this.selectedRecordForDeleteContact.next(any);
  }
  getSelectedRecordForDeleteContact(): Observable<any> {
    return this.selectedRecordForDeleteContact.asObservable();
  }

  sendSelectedRecordForFavoriteCore(any): void {
    this.selectedRecordForFavoriteCore.next(any);
  }
  getSelectedRecordForFavoriteCore(): Observable<any> {
    return this.selectedRecordForFavoriteCore.asObservable();
  }

  sendSelectedRecordForFavoriteContact(any): void {
    this.selectedRecordForFavoriteContact.next(any);
  }
  getSelectedRecordForFavoriteContact(): Observable<any> {
    return this.selectedRecordForFavoriteContact.asObservable();
  }

  sendSelectedRecordForDeleteFavoriteCore(any): void {
    this.selectedRecordForDeleteFavoriteCore.next(any);
  }
  getSelectedRecordForDeleteFavoriteCore(): Observable<any> {
    return this.selectedRecordForDeleteFavoriteCore.asObservable();
  }

  sendSelectedRecordForDeleteFavoriteContact(any): void {
    this.selectedRecordForDeleteFavoriteContact.next(any);
  }
  getSelectedRecordForDeleteFavoriteContact(): Observable<any> {
    return this.selectedRecordForDeleteFavoriteContact.asObservable();
  }

  sendSearchValueForCoreModule(filterValue): void {
    this.searchValueForCoreModule.next(filterValue);
  }
  getSearchValueForCoreModule(): Observable<string> {
    return this.searchValueForCoreModule.asObservable();
  }

  sendSearchValueForContactModule(filterValue): void {
    this.searchValueForContactModule.next(filterValue);
  }
  getSearchValueForContactModule(): Observable<any> {
    return this.searchValueForContactModule.asObservable();
  }

  sendAddListEventForCore(): void {
    this.AddListEventForCore.next();
  }
  getAddListEventForCore(): Observable<any> {
    return this.AddListEventForCore.asObservable();
  }

  sendAddListEventForContact(): void {
    this.AddListEventForContact.next();
  }
  getAddListEventForContact(): Observable<any> {
    return this.AddListEventForContact.asObservable();
  }

  sendSelectedColumnForCore(any): void {
    this.selectedColumnForCore.next(any);
  }
  getSelectedColumnForCore(): Observable<any> {
    return this.selectedColumnForCore.asObservable();
  }

  sendSelectedColumnForContact(any): void {
    this.selectedColumnForContact.next(any);
  }
  getSelectedColumnForContact(): Observable<any> {
    return this.selectedColumnForContact.asObservable();
  }

  sendAddFilterEventForCore(): void {
    this.AddFilterEventForCore.next();
  }
  getAddFilterEventForCore(): Observable<any> {
    return this.AddFilterEventForCore.asObservable();
  }

  sendAddFilterEventForContact(): void {
    this.AddFilterEventForContact.next();
  }
  getAddFilterEventForContact(): Observable<any> {
    return this.AddFilterEventForContact.asObservable();
  }

  sendSelectedCFilterNameForCore(any): void {
    this.selectedCFilterNameForCore.next(any);
  }
  getSelectedCFilterNameForCore(): Observable<object> {
    return this.selectedCFilterNameForCore.asObservable();
  }

  sendSelectedCFilterNameForContact(any): void {
    this.selectedCFilterNameForContact.next(any);
  }
  getSelectedCFilterNameForContact(): Observable<object> {
    return this.selectedCFilterNameForContact.asObservable();
  }

  sendSelectedDocumentForCore(any): void {
    this.selectedDocumentForCore.next(any);
  }
  getSelectedDocumentForCore(): Observable<object> {
    return this.selectedDocumentForCore.asObservable();
  }

  sendSelectedDocumentForFileManager(any): void {
    this.selectedDocumentForFileManager.next(any);
  }
  getSelectedDocumentForFileManager(): Observable<object> {
    return this.selectedDocumentForFileManager.asObservable();
  }

  sendSelectedDocumentForChat(any): void {
    this.selectedDocumentForChat.next(any);
  }
  getSelectedDocumentForChat(): Observable<object> {
    return this.selectedDocumentForChat.asObservable();
  }


  sendSelectedDocumentForCoreDetails(any): void {
    this.selectedDocumentForCoreDetails.next(any);
  }
  getSelectedDocumentForCoreDetails(): Observable<object> {
    return this.selectedDocumentForCoreDetails.asObservable();
  }

  sendSelectedDocumentForContactDetails(any): void {
    this.selectedDocumentForContactDetails.next(any);
  }
  getSelectedDocumentForContactDetails(): Observable<object> {
    return this.selectedDocumentForContactDetails.asObservable();
  }

  sendSelectedDocumentForCompanyDetails(any): void {
    this.selectedDocumentForCompanyDetails.next(any);
  }
  getSelectedDocumentForCompanyDetails(): Observable<object> {
    return this.selectedDocumentForCompanyDetails.asObservable();
  }

  sendSelectedDocumentForContact(any): void {
    this.selectedDocumentForContact.next(any);
  }
  getSelectedDocumentForContact(): Observable<object> {
    return this.selectedDocumentForContact.asObservable();
  }

  sendSelectedDocumentForCompany(any): void {
    this.selectedDocumentForCompany.next(any);
  }
  getSelectedDocumentForCompany(): Observable<object> {
    return this.selectedDocumentForCompany.asObservable();
  }


  sendSelectedFolderFileForm(any): void {
    this.sendSelectedFolderFileFormModule.next(any);
  }
  getSelectedFolderFileForm(): Observable<any> {
    return this.sendSelectedFolderFileFormModule.asObservable();
  }
  sendSelectedFolderContentFromLeftMenu(any: any): void {
    this.childFolderListContent.next(any);
  }
  childFolderList(): Observable<any> {
    return this.childFolderListContent.asObservable();
  }
  sendLoadSharedWithme(any: any): void {
    this.loadSharedWithMe.next(any);
  }
  getLoadSharedWithme(): Observable<any> {
    return this.loadSharedWithMe.asObservable();
  }
  sendSelectedFolderContentFromLeftMenuFileManager(any: any): void {
    this.childFolderListContentFileManager.next(any);
  }
  getSelectedFolderContentFromLeftMenuFileManager(): Observable<any> {
    return this.childFolderListContentFileManager.asObservable();
  }

  sendSelectedFolderDetailsFromLeftMenuFileManager(any: any): void {
    this.SelectedFolderDetailsFromLeftMenuFileManager.next(any);
  }
  getSelectedFolderDetailsFromLeftMenuFileManager(): Observable<any> {
    return this.SelectedFolderDetailsFromLeftMenuFileManager.asObservable();
  }

  getCurrentFormContact(): Observable<any>  {
    return this.getCurrentFormContactName.asObservable();
  }
  SendCurrentFormContact(any): void {
    return this.getCurrentFormContactName.next(any);
  }
  getCurrentFormName(): Observable<any>  {
    return this.getCurrentFormFormName.asObservable();
  }
  SendCurrentFormName(any): void {
    return this.getCurrentFormFormName.next(any);
  }

  getRequestMenu(): Observable<any>  {
    return this.getSendCurrentMenu.asObservable();
  }
  SendMenu(any): void {
    return this.getSendCurrentMenu.next(any);
  }

  getEmptyCurrentFormName(): Observable<any>  {
    return this.getEmptyCurrentFormFormName.asObservable();
  }
  SendEmptyCurrentFormName(any): void {
    return this.getEmptyCurrentFormFormName.next(any);
  }

  getCurrentFormContactFileManager(): Observable<any>  {
    return this.getCurrentFormContactNameFileManager.asObservable();
  }
  SendCurrentFormContactFileManager(any): void {
    return this.getCurrentFormContactNameFileManager.next(any);
  }

  getCurrentFormContactdashBoard(): Observable<any>  {
    return this.getCurrentFormContactNamedashBoard.asObservable();
  }
  SendCurrentFormContactdashBoard(any): void {
    return this.getCurrentFormContactNamedashBoard.next(any);
  }
  sendRefreshListForForm(any): void {
    this.sendRefreshListForFormModule.next(any);
  }

  getRefreshListForForm(): Observable<any> {
    return this.sendRefreshListForFormModule.asObservable();
  }

  sendRefreshListForFileManager(any): void {
    this.sendRefreshListForFileManagerModule.next(any);
  }

  getRefreshListForFileManager(): Observable<any> {
    return this.sendRefreshListForFileManagerModule.asObservable();
  }

  sendRenamedItemForFileManager(any): void {
    this.RenamedFileManagerItem.next(any);
  }

  getRenamedItemForFileManager(): Observable<any> {
    return this.RenamedFileManagerItem.asObservable();
  }

  //
  SendFolderDetailsEmpty(any): void {
    this.SetFolderEdtailEmpty.next(any);
  }

  getFolderDetailsEmpty(): Observable<any> {
    return this.SetFolderEdtailEmpty.asObservable();
  }
  //

  sendRefreshListForFileManagerAddFolder(any): void {
    this.sendRefreshListForFileManagerAdd.next(any);
  }

  getRefreshListForFileManagerAddFolder(): Observable<any> {
    return this.sendRefreshListForFileManagerAdd.asObservable();
  }

  sendRefreshDetailsSharedRoleListForForm(any): void {
    this.sendRefreshDetailsSharedRoleForFormModule.next(any);
  }

  getRefreshDetailsSharedRoleListForForm(): Observable<any> {
    return this.sendRefreshDetailsSharedRoleForFormModule.asObservable();
  }

  sendRefreshDetailsSharedRoleListForFileManager(any): void {
    this.sendRefreshDetailsSharedRoleForFileManagerModule.next(any);
  }

  getRefreshDetailsSharedRoleListForFileManager(): Observable<any> {
    return this.sendRefreshDetailsSharedRoleForFileManagerModule.asObservable();
  }

  sendSelectedFolderIDFromLeftMenuToDashBoard(any): void {
    this.sendSelectedFolderIDFromLeftMenu.next(any);
  }

  GetSelectedFolderIDFromLeftMenuToDashBoard(): Observable<any> {
    return this.sendSelectedFolderIDFromLeftMenu.asObservable();
  }


  sendSelectedFolderIDFromLeftMenuToDashBoardFileManager(any): void {
    this.sendSelectedFolderIDFromLeftMenuFileManager.next(any);
  }

  GetSelectedFolderIDFromLeftMenuToDashBoardFileManager(): Observable<any> {
    return this.sendSelectedFolderIDFromLeftMenuFileManager.asObservable();
  }

  sendSelectedFolderIDForAddFolder(any): void {
    this.sendSelectedFolderIDForAddFolderFileManager.next(any);
  }

  GetSelectedFolderIDForAddFolder(): Observable<any> {
    return this.sendSelectedFolderIDForAddFolderFileManager.asObservable();
  }

  sendSelectedParentFolderIDForMove(any): void {
    this.sendSelectedParentFolderIDForMoveFileMangerItem.next(any);
  }

  getSelectedParentFolderIDForMoveFileManagerItem():  Observable<any> {
   return this.sendSelectedParentFolderIDForMoveFileMangerItem.asObservable();
  }
  
  sendSelectedParentFormIDForMove(any): void {
    this.sendSelectedParentFormIDForMoveForm.next(any);
  }

  getSelectedParentFormIDForMoveForm():  Observable<any> {
   return this.sendSelectedParentFormIDForMoveForm.asObservable();
  }

  sendProjectNameAlreadyExist(any): void {
    this.sendProjectNameAlreadyExists.next(any);
  }

  GetProjectNameAlreadyExist(): Observable<any> {
    return this.sendProjectNameAlreadyExists.asObservable();
  }

  getTotalInbox(): Observable<any>  {
    return this.totalInbox.asObservable();
  }
  sendTotalInbox(any): void {
    return this.totalInbox.next(any);
  }

  sendSaveContactCreateNewParticipantStep2(any): void {
    this.ContactCreateNewParticipantStep2.next(any);
  }

  GetSaveContactCreateNewParticipantStep2(): Observable<any> {
    return this.ContactCreateNewParticipantStep2.asObservable();
  }
  

  sendSelectedRequestDocumentForCore(any): void {
    this.SelectedRequestDocumentForCore.next(any);
  }
  getSelectedRequestDocumentForCore(): Observable<object> {
    return this.SelectedRequestDocumentForCore.asObservable();
  }

  sendRemoveRequestDocumentForCore(any): void {
    this.RemoveRequestDocumentForCore.next(any);
  }
  getRemoveRequestDocumentForCore(): Observable<object> {
    return this.RemoveRequestDocumentForCore.asObservable();
  }

  sendRemoveFaxDocumentForCore(any): void {
    this.RemoveFaxDocumentForCore.next(any);
  }
  getRemoveFaxDocumentForCore(): Observable<object> {
    return this.RemoveFaxDocumentForCore.asObservable();
  }

  sendFillPlaceholderDocumentForCore(any): void {
    this.FillPlaceholderDocumentForCore.next(any);
  }
  getFillPlaceholderDocumentForCore(): Observable<object> {
    return this.FillPlaceholderDocumentForCore.asObservable();
  }


  // 
  sendSelectedRequestDocumentForContact(any): void {
    this.SelectedRequestDocumentForContact.next(any);
  }
  getSelectedRequestDocumentForContact(): Observable<object> {
    return this.SelectedRequestDocumentForContact.asObservable();
  }

  sendRemoveRequestDocumentForContact(any): void {
    this.RemoveRequestDocumentForContact.next(any);
  }
  getRemoveRequestDocumentForContact(): Observable<object> {
    return this.RemoveRequestDocumentForContact.asObservable();
  }

  sendFillPlaceholderDocumentForContact(any): void {
    this.FillPlaceholderDocumentForContact.next(any);
  }
  getFillPlaceholderDocumentForContact(): Observable<object> {
    return this.FillPlaceholderDocumentForContact.asObservable();
  }

  // 
  sendSelectedRequestDocumentForCompany(any): void {
    this.SelectedRequestDocumentForCompany.next(any);
  }
  getSelectedRequestDocumentForCompany(): Observable<object> {
    return this.SelectedRequestDocumentForCompany.asObservable();
  }

  sendSelectedFaxDocumentForFileManager(any): void {
    this.SelectedFaxDocumentForFileManager.next(any);
  }
  getSelectedFaxDocumentForFileManager(): Observable<object> {
    return this.SelectedFaxDocumentForFileManager.asObservable();
  }

  sendRemoveRequestDocumentForCompany(any): void {
    this.RemoveRequestDocumentForCompany.next(any);
  }
  getRemoveRequestDocumentForCompany(): Observable<object> {
    return this.RemoveRequestDocumentForCompany.asObservable();
  }

  sendRemoveFaxDocumentForFileManager(any): void {
    this.RemoveFaxDocumentForFileManager.next(any);
  }
  getRemoveFaxDocumentForFileManager(): Observable<object> {
    return this.RemoveFaxDocumentForFileManager.asObservable();
  }

  sendFillPlaceholderDocumentForCompany(any): void {
    this.FillPlaceholderDocumentForCompany.next(any);
  }
  getFillPlaceholderDocumentForCompany(): Observable<object> {
    return this.FillPlaceholderDocumentForCompany.asObservable();
  }

  sendNotificationRead(any): void {
    this.NotificationRead.next(any);
  }

  getNotificationRead(): Observable<any> {
    return this.NotificationRead.asObservable();
  }

  sendSelectedChatParticipant(any): void {
    this.SelectedChatParticipant.next(any);
  }
  getSelectedChatParticipant(): Observable<object> {
    return this.SelectedChatParticipant.asObservable();
  }

  sendSelectedChatGroups(any): void {
    this.SelectedChatParticipant.next(any);
  }
  getSelectedChatGroups(): Observable<object> {
    return this.SelectedChatParticipant.asObservable();
  }

  sendDeleteChatGroup(any): void {
    this.DeleteChatGroup.next(any);
  }
  getDeleteChatGroup(): Observable<object> {
    return this.DeleteChatGroup.asObservable();
  }
  sendNewChatMessageCountUpdate(any): void {
    this.NewChatMessage.next(any);
  }
  getNewChatMessageCountUpdate(): Observable<object> {
    return this.NewChatMessage.asObservable();
  }
  sendAddAttachmentFile(any): void {
    this.AddAttachmentFile.next(any);
  }
  getAddAttachmentFile(): Observable<object> {
    return this.AddAttachmentFile.asObservable();
  }

  sendMessageUserOrGroup(any): void {
    this.MessageUserOrGroup.next(any);
  }
  getMessageUserOrGroup(): Observable<object> {
    return this.MessageUserOrGroup.asObservable();
  }

  sendShowFormsSiderbar(any): void {
    this.ShowFormsSiderbar.next(any);
  }
  getShowFormsSiderbar(): Observable<object> {
    return this.ShowFormsSiderbar.asObservable();
  }


  sendSentSelectedDetail(any):void{
    this.SentSelectedDetail.next(any);
  }

  getSentSelectedDetail(): Observable<object> {
    return this.SentSelectedDetail.asObservable();
  }
  
  sendUpdateUserProfile(any): void {
    this.UpdateUserProfile.next(any);
  }
  getUpdateUserProfile(): Observable<any> {
    return this.UpdateUserProfile.asObservable();
  }

  sendOrganizationSelectedDetail(any):void{
    this.OrganizationSelectedDetail.next(any);
  }

  getOrganizationSelectedDetail(): Observable<object> {
    return this.OrganizationSelectedDetail.asObservable();
  }

  sendNextPreviousDocumentFromCore(filterValue): void {
    this.NextPreviousDocumentFromCore.next(filterValue);
  }
  getNextPreviousDocumentFromCore(): Observable<string> {
    return this.NextPreviousDocumentFromCore.asObservable();
  }


  openAIBindingFileDashboard(val): void {   
    this.openAIBindingPopup.next(val);
  }

  getopenAIBindingFileDashboard(): Observable<boolean> {   
    return this.openAIBindingPopup.asObservable();
  }

  sendNextPreviousForRightPanelFromCore(filterValue): void {
    this.NextPreviousForRightPanelFromCore.next(filterValue);
  }
  getNextPreviousForRightPanelFromCore(): Observable<string> {
    return this.NextPreviousForRightPanelFromCore.asObservable();
  }

  sendNextPreviousForTouchesFromCore(filterValue): void {
    this.NextPreviousForTouchesFromCore.next(filterValue);
  }
  getNextPreviousForTouchesFromCore(): Observable<string> {
    return this.NextPreviousForTouchesFromCore.asObservable();
  }

  sendNextPreviousForTaskFrom3C(filterValue): void {
    this.NextPreviousForTaskFromCore.next(filterValue);
  }
  getNextPreviousForTaskFrom3C(): Observable<string> {
    return this.NextPreviousForTaskFromCore.asObservable();
  }

  sendNextPreviousDocumentFromContact(filterValue): void {
    this.NextPreviousDocumentFromContact.next(filterValue);
  }
  getNextPreviousDocumentFromContact(): Observable<string> {
    return this.NextPreviousDocumentFromContact.asObservable();
  }

  sendNextPreviousForRightPanelFromContact(filterValue): void {
    this.NextPreviousForRightPanelFromContact.next(filterValue);
  }
  getNextPreviousForRightPanelFromContact(): Observable<string> {
    return this.NextPreviousForRightPanelFromContact.asObservable();
  }

  sendNextPreviousForTouchesFromContact(filterValue): void {
    this.NextPreviousForTouchesFromContact.next(filterValue);
  }
  getNextPreviousForTouchesFromContact(): Observable<string> {
    return this.NextPreviousForTouchesFromContact.asObservable();
  }

  sendNextPreviousDocumentFromCompany(filterValue): void {
    this.NextPreviousDocumentFromCompany.next(filterValue);
  }
  getNextPreviousDocumentFromCompany(): Observable<string> {
    return this.NextPreviousDocumentFromCompany.asObservable();
  }

  sendNextPreviousForRightPanelFromCompany(filterValue): void {
    this.NextPreviousForRightPanelFromCompany.next(filterValue);
  }
  getNextPreviousForRightPanelFromCompany(): Observable<string> {
    return this.NextPreviousForRightPanelFromCompany.asObservable();
  }

  sendNextPreviousForTouchesFromCompany(filterValue): void {
    this.NextPreviousForTouchesFromCompany.next(filterValue);
  }
  getNextPreviousForTouchesFromCompany(): Observable<string> {
    return this.NextPreviousForTouchesFromCompany.asObservable();
  }

  sendSelectedHTMLDataForCore(any): void {
    this.selectedHTMLDataForCore.next(any);
  }
  getSelectedHTMLDataForCore(): Observable<any> {
    return this.selectedHTMLDataForCore.asObservable();
  }

  sendSelectedHTMLDataForContact(any): void {
    this.selectedHTMLDataForContact.next(any);
  }
  getSelectedHTMLDataForContact(): Observable<any> {
    return this.selectedHTMLDataForContact.asObservable();
  }
  sendSelectedHTMLDataForCompany(any): void {
    this.selectedHTMLDataForCompany.next(any);
  }
  getSelectedHTMLDataForCompany(): Observable<any> {
    return this.selectedHTMLDataForCompany.asObservable();
  }

  sendSelectedHTMLDataForForm(any): void {
    this.selectedHTMLDataForForm.next(any);
  }
  getSelectedHTMLDataForForm(): Observable<object> {
    return this.selectedHTMLDataForForm.asObservable();
  }

  sendselectedPdfFormDataForForm(any): void {
    this.selectedPdfFormDataForForm.next(any);
  }
  getselectedPdfFormDataForForm(): Observable<object> {
    return this.selectedPdfFormDataForForm.asObservable();
  }

  sendHideTaskListCore(): void {
    this.HideTaskListCore.next();
  }

  getHideTaskListCore(): Observable<any> {
    return this.HideTaskListCore.asObservable();
  }


  sendSelectedDocForBindAI(any): void {
    this.sendSelectedDocForBindAIs.next(any);
  }
  getSelectedDocForBindAI(): Observable<object> {
    return this.sendSelectedDocForBindAIs.asObservable();
  }
  
  sendUpdateDataUsingAIForCore(filterValue): void {
    this.UpdateDataUsingAIForCore.next(filterValue);
  }
  getUpdateDataUsingAIForCore(): Observable<string> {
    return this.UpdateDataUsingAIForCore.asObservable();
  }

  sendSelectedDocForBindAIForms(any): void {
    this.sendSelectedDocForBindAIsForms.next(any);
  }
  getSelectedDocForBindAIForms(): Observable<object> {
    return this.sendSelectedDocForBindAIsForms.asObservable();
  }

  sendRefreshListFromCore(any): void {
    this.sendRefreshListForCore.next(any);
  }

  getRefreshListFromCore(): Observable<object> {
    return this.sendRefreshListForCore.asObservable();
  }
  
  sendGroupingList3C(): void {
    this.senndGroupingList3C.next();
  }

  GetGroupingList3C(): Observable<any> {
    return this.senndGroupingList3C.asObservable();
  }

  sendSelectedDocForBindAITools(any): void {
    this.sendSelectedDocForBindAIToolss.next(any);
  }
  getSelectedDocForBindAITools(): Observable<object> {
    return this.sendSelectedDocForBindAIToolss.asObservable();
  }

  sendSelectedDocForGoogleDrive(any): void {
    this.sendDataGoogleDrive.next(any);
  }
  getSelectedDocForGoogleDrive(): Observable<object> {
    return this.sendDataGoogleDrive.asObservable();
  }

  sendRefreshListAfterAddingParticipant(any): void {
    this.sendRefreshListAfterAddingParticipants.next(any);
  }

  getRefreshListAfterAddingParticipant(): Observable<object> {
    return this.sendRefreshListAfterAddingParticipants.asObservable();
  }

}
